export default __webpack_public_path__ + "static/bed-bath-beyond-3-bb-005a4b0049159d7db8b958309cfc56ac.webp";